import { blinkerAnimation } from '@app/core/ui/animations';
import { formatThousands } from '@mi-front/core';
import { LocaleRelativeTime } from '@mi-front/ui';
import YouTubeIcon from '@mui/icons-material/YouTube';
import { Chip, Tooltip } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export type YoutubeLiveCounterDisplayProps = {
  /** Live viewer count; ignored for label when `isOffline` (chip shows "OFFLINE"). */
  viewers: number;
  /** True when the source has no usable viewer data (missing series, error shape, etc.). */
  isOffline: boolean;
  time: string | number | null;
};

/**
 * Shared chip + tooltip for the stream header YouTube live viewer count (legacy and BFF sources).
 */
export function YoutubeLiveCounterDisplay({
  viewers,
  isOffline,
  time,
}: YoutubeLiveCounterDisplayProps) {
  return (
    <Tooltip
      title={
        <>
          <FormattedMessage
            id="logger.streamScreen.controls.youtubeLiveViewers"
            defaultMessage="{count} espectadores en vivo"
            values={{
              count: isOffline ? '—' : viewers.toLocaleString(),
            }}
          />
          {time != null && (
            <div>
              <FormattedMessage
                id="logger.streamScreen.controls.updated"
                defaultMessage="Actualizado <time>{time}</time>"
                values={{
                  time: () => <LocaleRelativeTime value={time} />,
                }}
              />
            </div>
          )}
        </>
      }
      placement="top"
    >
      <Chip
        sx={{
          paddingLeft: 0.5,
          opacity: isOffline ? 0.5 : 1,
          cursor: 'default',
          '& .MuiChip-label': {
            cursor: 'default',
            userSelect: 'none',
          },
        }}
        icon={
          <YouTubeIcon
            color="error"
            sx={{
              color: isOffline ? '#888' : 'red',
              animation: blinkerAnimation,
            }}
          />
        }
        variant="outlined"
        label={isOffline ? 'OFFLINE' : formatThousands(viewers)}
      />
    </Tooltip>
  );
}
